import Footer from "./Components/Footer";
import Header from "./Components/Header";
import Routing from "./Routing";
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';


function App() {
  // document.addEventListener("contextmenu", (e) => e.preventDefault());
  // document.addEventListener("dragstart", (e) => e.preventDefault());
  return (
    <div>
      <Header />
      <Routing />
      <Footer />
    </div>
  );
}

export default App;
